import { trackComponent } from "@repo/analytics";
import { dlEventConstants } from "@repo/analytics/data-layer.constants";
import { getCustomerIdForAnalytics } from "../../utils/analytics-utils";

export const recentlyViewedTrackAnalytics = {
  componentName: "stocks_market_card_sku_details",
  referenceId: "recently_viewed",
  propertyType: "clp",
  productName: "trading_mall",
  productCategory: "stocks",
  clickTypes: {
    cardClick: "stocks_market_card_sku_details_card_click",
    carouselClick: "stocks_market_card_sku_details_carousel_click",
  },
} as const;

interface TrackRecentlyViewedClickInput {
  clickType: string;
  sectionTitle: string;
  ctaText: string;
  componentPosition?: string;
  destinationUrl?: string;
  tabPosition?: string;
}

export async function trackRecentlyViewedClick({
  clickType,
  sectionTitle,
  ctaText,
  componentPosition,
  destinationUrl,
  tabPosition,
}: TrackRecentlyViewedClickInput): Promise<void> {
  try {
    const customerId = await getCustomerIdForAnalytics();

    await trackComponent({
      componentName: recentlyViewedTrackAnalytics.componentName,
      componentId: recentlyViewedTrackAnalytics.referenceId,
      sectionTitle,
      eventType: dlEventConstants.CLICK,
      clickType,
      ctaText,
      destinationUrl,
      componentPosition,
      tabPosition,
      productName: recentlyViewedTrackAnalytics.productName,
      productCategory: recentlyViewedTrackAnalytics.productCategory,
      pageType: recentlyViewedTrackAnalytics.propertyType,
      cleverTapOverrides: {
        EP_PROPERTY_TYPE: recentlyViewedTrackAnalytics.propertyType,
        EP_PRODUCT_NAME: recentlyViewedTrackAnalytics.productName,
        EP_PRODUCT_CATEGORY: recentlyViewedTrackAnalytics.productCategory,
        EP_REFERENCE_ID: recentlyViewedTrackAnalytics.referenceId,
        ...(customerId && { EP_CUSTOMER_ID: customerId }),
        ...(componentPosition && { EP_SR_NUMBER: componentPosition }),
      },
    });
  } catch (error) {
    console.error("Failed to track recently viewed click", error);
  }
}
